<div class="grid grid-rows-4 h-[15vh] w-full">
    <div>
        <span class="flex items-center justify-end" mat-dialog-close mat-icon-button style="cursor: pointer" (click)="closeDialogBox()">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
    </div>
    <div>
        <hr class="relative top-[-0.3vh]">
    </div>
    <div class="w-full relative bottom-[3vh]">
        <p class=" content " *ngIf="isAdmin">
            Are you sure you want to permanently delete this exclusion?
        </p>
        <p class=" content " *ngIf="!isAdmin">
            Are you sure you want to permanently delete this record?
        </p>
    </div>
    <div class="grid grid-cols-2 relative bottom-[3vh] " *ngIf="isAdmin">
        <div class="grid justify-end relative left-[5vw]">
            <button class="cancelBtn" (click)="closeDialogBox()">
                <p class="cancelText">Cancel</p>
            </button>
        </div>
        <div class="grid justify-end">
            <button class="deleteBtn relative top-[0vh] left-[0vw]" (click)="deleteThisExclusion()">
                <p class="btnText">Delete</p>
            </button>
        </div>
    </div>
    <div class="grid grid-cols-2 relative bottom-[3vh] " *ngIf="!isAdmin">
        <div class="grid justify-end relative left-[5vw] top-[2vh]">
            <button class="cancelRecordBtn" (click)="closeDialogBox()">
                <p class="cancelRecordText">Cancel</p>
            </button>
        </div>
        <div class="grid justify-end">
            <button class="deleteRecordBtn relative top-[2vh] left-[0vw]" (click)="deleteThisExclusion()">
                <p class="btnRecordText">Delete</p>
            </button>
        </div>
    </div>
</div>